var yardPlanner = (function (module, $) {
  var ypButtonLink,
    ypLinkCreateList,
    ypButtonCreateList,
    ypNewListCreator,
    ypHiddenCustomer,
    ypListsWrapper,
    ypLists,
    ypNameInput,
    ypProductObject,
    ypListItemTemplate,
    ypSavedLists,
    ypSharedItemTemplate,
    ypSharedList,
    ypSection,
    ypUserId,
    $body;

  var init = function (customerId) {
    var ypButtonLink = $("#YardPlannerButtonLink");
    ypLinkCreateList = $("#YardPlannerLinkCreateList");
    ypButtonCreateList = $("#YardPlannerButtonCreateNewList");
    ypNewListCreator = $("#YardPlannerNewListCreator");
    ypHiddenCustomer = $("#YardPlannerHiddenCustomer");
    ypUserId =
      typeof customerId === "undefined" ? ypHiddenCustomer.val() : customerId;
    ypListsWrapper = $("#YardPlannerListsWrapper");
    ypLists = $("#YardPlannerLists");
    ypNameInput = $("#YardPlannerNewListName");
    ypProductObject = Object.assign(
      JSON.parse($("#YardPlannerProductJson").html()),
      JSON.parse($("#YardPlannerProductMetaJson").html())
    );
    ypListItemTemplate = Handlebars.compile(
      $("#YardPlannerListItemTemplate").html()
    );
    ypSavedLists =
      typeof localStorage.getItem("FGTYardPlannerLists") === "undefined"
        ? []
        : localStorage.getItem("FGTYardPlannerLists") !== "undefined"
        ? JSON.parse(localStorage.getItem("FGTYardPlannerLists"))
        : [];

    ypButtonLink.on("click", function (e) {
      e.preventDefault();
      var trigger = $(this).data("trigger");
      if (trigger === "YardPlannerListsWrapper") {
        var id = ypHiddenCustomer.val();
        getLists(id);
      } else {
        $("#" + trigger).slideDown();
      }
    });

    ypLinkCreateList.on("click", function (e) {
      e.preventDefault();
      ypNewListCreator.slideDown();
    });

    ypButtonCreateList.on("click", function (e) {
      e.preventDefault();
      $("#YardPlannerListsWrapper").addClass("loading");
      createList();
    });

    ypNameInput.on("keydown", function (e) {
      var code = e.keyCode || e.which;
      if (code === 13) {
        e.preventDefault();
        ypButtonCreateList.click();
      }
    });

    ypLists.on("click", ".yard-planner-list-link", function (e) {
      e.preventDefault();
      var $link = $(this);
      addToList($link.data("id"), $link.data("name"));
    });
  };

  var getLists = function () {
    var errorDiv =
      $("#YardPlannerGetListsError").length === 1
        ? $("#YardPlannerGetListsError")
        : $("<div />", { id: "YardPlannerGetListsError" });
    errorDiv.addClass("yard-planner-error");
    errorDiv.empty().remove();
    $("#YardPlannerWrapper").addClass("loading");
    $.ajax({
      type: "GET",
      url:
        "https://ugz7uiahmb.execute-api.us-east-1.amazonaws.com/v1/customers/" +
        ypUserId +
        "/wishlists?noUpdate",
      success: function (response) {
        $("#YardPlannerWrapper").removeClass("loading");
        if (response.length === 0) {
          ypLists.html($("<li />", { text: "Create a new list to continue!" }));
          ypListsWrapper.slideDown();
          return;
        }
        ypSavedLists = response;
        localStorage.setItem(
          "FGTYardPlannerLists",
          JSON.stringify(ypSavedLists)
        );
        var tmplLists = ypSavedLists;
        var listLength = tmplLists.length;
        for (var i = 0; i < listLength; i++) {
          var list = tmplLists[i];
          if (list.items) {
            var itemsLength = list.items.length;
            for (var j = 0; j < itemsLength; j++) {
              list.hasItem =
                parseInt(list.items[j].itemId, 10) ===
                parseInt(ypProductObject.id, 10);
            }
          }
        }
        ypLists.html(ypListItemTemplate({ lists: tmplLists }));
        ypListsWrapper.slideDown();
      },
      error: function (xhr, status, error) {
        $("#YardPlannerWrapper").removeClass("loading");
        if (xhr.status !== 404) {
          errorDiv.text("Your list(s) could not be retrieved at this time.");
          ypListsWrapper.before(errorDiv).slideDown();
          console.error(xhr, status, error);
        } else {
          ypLists.html($("<li />", { text: "Create a new list to continue!" }));
          ypListsWrapper.slideDown();
        }
      },
    });
  };

  var createList = function (callback) {
    var errorDiv =
        $("#YardPlannerCreateListError").length === 1
          ? $("#YardPlannerCreateListError")
          : $("<div />", { id: "YardPlannerCreateListError" }),
      fields = ypNameInput.closest(".form-fields");
    errorDiv.addClass("yard-planner-error");
    ypSavedLists =
      JSON.parse(localStorage.getItem("FGTYardPlannerLists")) || [];
    if (ypNameInput.val().trim().length < 1) {
      errorDiv.text("List name is required");
      fields.after(errorDiv);
    } else {
      var newLower = ypNameInput.val().trim().toLowerCase(),
        found =
          ypSavedLists.length > 0
            ? ypSavedLists.find(function (el) {
                return el.name.toLowerCase() === newLower;
              })
            : false;
      if (found) {
        errorDiv.html(
          "List '<em>" + ypNameInput.val().trim() + "</em>' already exists."
        );
        fields.after(errorDiv);
        ypNameInput.val("").focus();
        return false;
      } else {
        $("#YardPlannerWrapper").addClass("loading");
        errorDiv.empty().remove();
        var listModel = {
          WishlistName: ypNameInput.val().trim(),
        };
        $.ajax({
          type: "POST",
          contentType: "application/json",
          data: JSON.stringify(listModel),
          url:
            "https://ugz7uiahmb.execute-api.us-east-1.amazonaws.com/v1/customers/" +
            ypUserId +
            "/wishlists",
          success: function (response) {
            $("#YardPlannerWrapper").removeClass("loading");
            window.dataLayer.push({
              event: "yardPlannerCreateList",
              yardPlannerListName: listModel.WishlistName,
              yardPlannerUserId: ypUserId,
            });
            if (typeof callback === "function") {
              callback(response);
            } else {
              ypSavedLists.push(response);
              var tmplLists = ypSavedLists;
              var listLength = tmplLists.length;
              for (var i = 0; i < listLength; i++) {
                var list = tmplLists[i];
                var itemsLength = list.items.length;
                for (var j = 0; j < itemsLength; j++) {
                  list.hasItem =
                    parseInt(list.items[j].itemId, 10) ===
                    parseInt(ypProductObject.id, 10);
                }
              }
              ypLists.html(ypListItemTemplate({ lists: tmplLists }));
              localStorage.setItem(
                "FGTYardPlannerLists",
                JSON.stringify(ypSavedLists)
              );
              $("#YardPlannerListsWrapper").removeClass("loading");
              ypNameInput.val("");
              ypLists.animate({ scrollTop: "100%" });
              ypNewListCreator.slideUp();
            }
          },
          error: function (xhr, status, error) {
            $("#YardPlannerWrapper").removeClass("loading");
            errorDiv.text(
              listModel.WishlistName + " could not be created at this time."
            );
            fields.after(errorDiv);
            console.error(xhr, status, error);
          },
        });
      }
    }
  };

  var addToList = function (listId, listName) {
    $("#YardPlannerWrapper").addClass("loading");
    var errorDiv =
      $("#YardPlannerAddToListError").length === 1
        ? $("#YardPlannerAddToListError")
        : $("<div />", { id: "YardPlannerAddToListError" });
    var successDiv =
      $("#YardPlannerAddToListSuccess").length === 1
        ? $("#YardPlannerAddToListSuccess")
        : $("<div />", { id: "YardPlannerAddToListSuccess" });
    errorDiv.addClass("yard-planner-error").empty().remove();
    successDiv.addClass("yard-planner-success").empty().remove();
    var itemModel = {
      ItemId: ypProductObject.id,
      VariantId: $(".faux-radio-list.active").data("value"),
    };
    ypSavedLists = JSON.parse(localStorage.getItem("FGTYardPlannerLists"));
    var listsLength = ypSavedLists.length;
    for (var i = 0; i < listsLength; i++) {
      if (ypSavedLists[i].id + "" === listId + "") {
        if (typeof ypSavedLists[i].Items === "undefined") {
          ypSavedLists[i].Items = [itemModel];
        } else {
          ypSavedLists[i].Items.push(itemModel);
        }
        localStorage.setItem(
          "FGTYardPlannerLists",
          JSON.stringify(ypSavedLists)
        );
        break;
      }
    }
    var dataModel = {
      botanicalName: ypProductObject.botanical_name,
      handle: ypProductObject.handle,
      image: ypProductObject.featured_image,
      itemId: ypProductObject.id,
      price: ypProductObject.price,
      title: ypProductObject.title,
      variantId: $(".faux-radio-list.active").data("value"),
      variants: ypProductObject.variants,
    };
    $.ajax({
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(dataModel),
      url:
        "https://ugz7uiahmb.execute-api.us-east-1.amazonaws.com/v1/customers/" +
        ypUserId +
        "/wishlists/" +
        listId +
        "/items",
      success: function (response) {
        window.dataLayer.push({
          event: "yardPlannerAddItem",
          yardPlannerListName: listName,
          yardPlannerListId: listId,
          yardPlannerProductTitle: ypProductObject.title,
          yardPlannerVariantTitle: $(".faux-radio-list.active .faux-radio-box")
            .text()
            .trim(),
          yardPlannerItemId: dataModel.itemId,
          yardPlannerVariantId: dataModel.variantId,
          yardPlannerUserId: ypUserId,
        });
        var $a = $("<a />", {
          href: "/account?view=yard_planner",
          html:
            ypProductObject.title +
            " has been added to your '<strong>" +
            listName +
            "</strong>' list.",
        });
        successDiv.html($a);
        ypListsWrapper.before(successDiv).slideUp();
        $("#YardPlannerWrapper").removeClass("loading");
      },
      error: function (xhr, status, error) {
        errorDiv.html(
          "There was an error adding " +
            ypProductObject.title +
            " to your list."
        );
        ypListsWrapper.prepend(errorDiv);
        console.error(xhr, status, error);
        $("#YardPlannerWrapper").removeClass("loading");
      },
    });
  };

  var buildListData = function (data) {
    var hasActiveVariant = false,
      itemsLength = data.items ? data.items.length : 0,
      isAvailable = function (variant) {
        return variant.available;
      };
    for (var i = 0; i < itemsLength; i++) {
      var item = data.items[i];
      // only show the variants that are available
      var availableVariants = item.variants.filter(isAvailable);
      var variantsLength = availableVariants.length;
      hasActiveVariant = false;
      for (var j = 0; j < variantsLength; j++) {
        var variant = availableVariants[j];
        if (variant.id === item.variantId) {
          // highlight the variant the user originally added
          variant.active = true;
          item.price = variant.price;
          item.canBuy = variant.price !== 999;
          hasActiveVariant = true;
        }
        variant.price =
          variant.price % 1 === 0 ? variant.price / 100 : variant.price;
      }
      item.price = item.price % 1 === 0 ? item.price / 100 : item.price;
      if (!hasActiveVariant) {
        availableVariants[0].active = true;
        item.price = availableVariants[0].price;
      }
    }
    return data;
  };

  var getSharedList = function (listd) {
    var url = new URL(location.href);
    var wlid = url.searchParams.get("wlid");
    var cid = url.searchParams.get("cid");
    if (typeof wlid !== "undefined" && typeof cid !== "undefined") {
      $.ajax({
        url:
          "https://ugz7uiahmb.execute-api.us-east-1.amazonaws.com/v1/customers/" +
          cid +
          "/wishlists/" +
          wlid,
        success: function (list) {
          ypSharedListJson = list;
          var listData = buildListData(list);
          window.dataLayer.push({
            event: "yardPlannerViewSharedList",
            yardPlannerListId: wlid,
            yardPlannerListName: list.name,
          });
          ypSharedList.html(ypSharedItemTemplate(listData));
          $("#YardPlannerSection-yard-planner-shared").removeClass("loading");
        },
        error: function (XMLHttpRequest, textStatus) {
          $("#YardPlannerSection-yard-planner-shared").removeClass("loading");
          if (XMLHttpRequest.status === 404) {
            $("#YardPlannerSharedList").html("<h3>List not found</h3>");
          } else {
            console.error(XMLHttpRequest, textStatus);
          }
        },
      });
    }
  };

  var handleVariantChange = function (e) {
    e.preventDefault();
    var $el = $(e.target).closest("li");
    var $row = $el.closest(".yard-planner-list-item");
    var $price = $row.find(".yard-planner-item-price a");
    $el.siblings("li").removeClass("active");
    $el.addClass("active");
    $price.text("$" + $el.data("price"));
    if ($el.data("price") === 999) {
      $row.find(".yard-planner-item-price").addClass("visually-hidden");
      $row.find(".btn-yard-planner-add-to-cart").addClass("visually-hidden");
      $row.find(".yard-planner-call-to-order").removeClass("visually-hidden");
    } else {
      $row.find(".btn-yard-planner-add-to-cart").removeClass("visually-hidden");
      $row.find(".yard-planner-item-price").removeClass("visually-hidden");
      $row.find(".yard-planner-call-to-order").addClass("visually-hidden");
    }
  };

  var addItemToCart = function (e) {
    $body.addClass("page--is-loading");
    var $button =
      e.target.nodeName === "SPAN"
        ? $(e.target).closest("button")
        : $(e.target);
    if ($button.hasClass("added") || $button.hasClass("adding") === true) {
      return false;
    }
    $button.addClass("adding");
    var $row = $button.closest(".yard-planner-list-item");
    var itemId = $row.data("itemid");
    var variantId = $row.find(".faux-radio-list.active").data("value");
    var variantName = $row
      .find(".faux-radio-list.active .faux-radio-box")
      .text()
      .trim();
    var quantity = $row.find(".product-selector__num").val();
    var name = $row.find(".yard-planner-item-name a").text().trim();
    var $success = $row.find(".yard-planner-added-success");
    var $error = $row.find(".yard-planner-added-error");
    $success.addClass("visually-hidden");
    $error.addClass("visually-hidden");
    var data = {
      id: variantId,
      quantity: quantity,
    };
    var params = {
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      beforeSend: function () {
        $body.trigger("beforeAddItem.ajaxCart", false);
      },
      success: function (line_item) {
        console.log(line_item, name, itemId, variantName, variantId);
        window.dataLayer.push({
          event: "yardPlannerAddItemToCart",
          yardPlannerListName: $row.data("listname"),
          yardPlannerListId: $row.data("listid"),
          yardPlannerProductTitle: name,
          yardPlannerItemId: itemId,
          yardPlannerVariantTitle: variantName,
          yardPlannerVariantId: variantId,
          yardPlannerItemQuantity: quantity,
          yardPlannerUserId: ypUserId,
        });
        $body.trigger("afterAddItem.ajaxCart", [line_item, false]);
        ajaxCart.load();
        $button.addClass("added").removeClass("adding");
        $success
          .text("Added " + name + " to your cart.")
          .removeClass("visually-hidden");
        setInterval(function () {
          $button.removeClass("adding").removeClass("added");
          $success.addClass("visually-hidden");
        }, 3000);
      },
      error: function (XMLHttpRequest, textStatus) {
        console.error(XMLHttpRequest, textStatus);
        $body
          .removeClass("page--is-loading")
          .trigger("errorAddItem.ajaxCart", [XMLHttpRequest, textStatus]);
        $button.removeClass("adding").removeClass("added");
        $error
          .text("There was an error adding " + name + " to your cart.")
          .removeClass("visually-hidden");
      },
      complete: function (jqxhr, text) {
        $body.trigger("completeAddItem.ajaxCart", [this, jqxhr, text]);
        $body.removeClass("page--is-loading");
      },
    };
    jQuery.ajax(params);
  };

  var sharedList = function () {
    $body = $("body");
    ypSharedItemTemplate = Handlebars.compile(
      $("#YardPlannerSharedListTmpl").html()
    );
    ypSharedList = $("#YardPlannerSharedList");
    getSharedList();
    ypSharedList.on(
      "click",
      ".faux-radio .faux-radio-list",
      handleVariantChange
    );
    ypSharedList.on("click", ".btn-yard-planner-add-to-cart", addItemToCart);
    ypSharedList.on("click", ".product-selector__adjust--plus", function (e) {
      e.preventDefault();
      var qtyBox = $(this).siblings(".product-selector__num");
      var val = parseInt(qtyBox.val().trim(), 10);
      qtyBox.val(val + 1);
    });
    ypSharedList.on("click", ".product-selector__adjust--minus", function (e) {
      e.preventDefault();
      var qtyBox = $(this).siblings(".product-selector__num");
      var val = parseInt(qtyBox.val().trim(), 10);
      if (val > 1) {
        qtyBox.val(val - 1);
      }
    });
  };

  var getUserLists = function () {
    ypSection.addClass("loading");
    $.get(
      "https://ugz7uiahmb.execute-api.us-east-1.amazonaws.com/v1/customers/" +
        ypUserId +
        "/wishlists",
      function (data) {
        data.lists = [];
        for (var i = 0; i < data.length; i++) {
          data.lists.push(buildListData(data[i]));
        }
        ypSavedLists = data.lists;
        localStorage.setItem(
          "FGTYardPlannerLists",
          JSON.stringify(ypSavedLists)
        );
        data.lists[0].active = true;
        ypUserLists.html(ypUserListsTemplate(data));
        ypSection.removeClass("loading");
        window.dataLayer.push({
          event: "yardPlannerViewOwnList",
          yardPlannerListName: data.lists[0].name,
          yardPlannerListId: data.lists[0].wishlistId,
          yardPlannerUserId: ypUserId,
        });
      }
    );
  };

  var toggleCreateList = function (e) {
    e.preventDefault();
    $("#YardPlannerNewListCreator").slideToggle();
  };

  var toggleListsAccordion = function (e) {
    e.preventDefault();
    var $header = $(e.target).closest(".yard-planner-list-header");
    var $newActive = $header.next(".yard-planner-list-items-wrapper");
    $(".yard-planner-list-items-wrapper.active")
      .not($newActive)
      .slideUp(250, "swing", function () {
        $(".yard-planner-list-header.active")
          .not($header)
          .removeClass("active");
        $(".yard-planner-list-items-wrapper.active")
          .not($newActive)
          .removeClass("active");
      });
    if (!$newActive.is(":visible")) {
      $newActive.slideDown(350, "swing", function () {
        $header.addClass("active");
        $newActive.addClass("active");
        window.dataLayer.push({
          event: "yardPlannerViewOwnList",
          yardPlannerListName: $header
            .find(".yard-planner-header-name span")
            .text()
            .trim(),
          yardPlannerListId: $header.data("list"),
          yardPlannerUserId: ypUserId,
        });
      });
    }
  };

  var createListUser = function (response) {
    ypSection.removeClass("loading");
    $(".yard-planner-list-header.active").removeClass("active");
    $(".yard-planner-list-items-wrapper.active").removeClass("active");
    ypSavedLists.push(response);
    localStorage.setItem("FGTYardPlannerLists", JSON.stringify(ypSavedLists));
    ypNameInput.val("");
    $("#YardPlannerCreateList").click();
    var newHeader = $("<div />", {
      class: "yard-planner-list-header active",
      "data-list": response.wishlistId,
    });
    var newHeaderHtml = `<i class="fal fa-plus-square"></i><i class="fal fa-minus-square"></i> ${response.name}`;
    var newName = $("<div />", {
      class: "yard-planner-header-name",
      html: newHeaderHtml,
    });
    var newListHtml = `<div class="yard-planner-list-item empty">
        <h3 class="yard-planner-item-name">
          <a href="/collections/all">Add items to your list</a>
        </h3>
      </div>`;
    var newListWrapper = $("<div />", {
      class: "yard-planner-list-items-wrapper active",
      html: newListHtml,
    });
    $(".yard-planner-lists-title").after(newHeader.append(newName));
    newHeader.after(newListWrapper);
  };

  var removeListItem = function (row) {
    var itemId = row.data("itemid");
    var itemName = row.find(".yard-planner-item-name a").text().trim();
    var variantName = row
      .find(".faux-radio-list.active .faux-radio-box")
      .text()
      .trim();
    var listId = row.data("listid");
    var listName = row.data("listname");
    var listItemsWrapper = row.closest(".yard-planner-list-items-wrapper");
    var listHeader = listItemsWrapper.prev(".yard-planner-list-header");
    $.ajax({
      type: "DELETE",
      dataType: "text",
      url:
        "https://ugz7uiahmb.execute-api.us-east-1.amazonaws.com/v1/customers/" +
        ypUserId +
        "/wishlists/" +
        listId +
        "/items/" +
        itemId,
      success: function (response) {
        window.dataLayer.push({
          event: "yardPlannerRemoveItem",
          yardPlannerListName: listName,
          yardPlannerListId: listId,
          yardPlannerProductTitle: itemName,
          yardPlannerVariantTitle: variantName,
          yardPlannerUserId: ypUserId,
        });
        row.slideUp(200, "swing", function () {
          if (listItemsWrapper.find(".yard-planner-list-item").length === 1) {
            row.empty();
            var newHTML = `<div class="yard-planner-list-item empty">
            <h3 class="yard-planner-item-name">
              <a href="/collections/all">Add items to your list</a>
            </h3>
          </div>`;
            row.removeClass("grid").addClass("empty").html(newHTML).slideDown();
            listHeader.find(".yard-planner-share-link").remove();
            listHeader.find(".yard-planner-print-link").remove();
          } else {
            row.remove();
          }
        });
      },
      error: function (xhr, status, error) {
        console.error(xhr, status, error);
      },
    });
  };

  var deleteUserList = function (listId) {
    var $header = $('.yard-planner-list-header[data-list="' + listId + '"');
    var $wrapper = $(
      '.yard-planner-list-items-wrapper[data-list="' + listId + '"'
    );
    $("#modalDeleteListBg").addClass("is-showing");
    $("#BtnDeleteListConfirm")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $.ajax({
          type: "DELETE",
          url:
            "https://ugz7uiahmb.execute-api.us-east-1.amazonaws.com/v1/customers/" +
            ypUserId +
            "/wishlists/" +
            listId,
          contentType: "application/json",
          dataType: "text",
          success: function (response) {
            window.dataLayer.push({
              event: "yardPlannerDeleteList",
              yardPlannerListName: $header
                .find(".yard-planner-header-name span")
                .text()
                .trim(),
              yardPlannerListId: listId,
              yardPlannerUserId: ypUserId,
            });
            for (var i = 0; i < ypSavedLists.length; i++) {
              if (ypSavedLists[i].wishlistId === listId) {
                ypSavedLists.splice(i, 1);
              }
            }
            localStorage.setItem(
              "FGTYardPlannerLists",
              JSON.stringify(ypSavedLists)
            );
            $header.slideUp(100, "swing", function () {
              $header.remove();
            });
            $wrapper.slideUp(100, "swing", function () {
              $wrapper.remove();
            });
            $("#modalDeleteListBg").removeClass("is-showing");
          },
          error: function (xhr, status, error) {
            console.error("xhr: ", xhr, "status: ", status, "error: ", error);
          },
        });
      });
    $("#BtnDeleteListDecline")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $("#modalDeleteListBg").removeClass("is-showing");
      });
  };

  var showShareModal = function (show, list, id) {
    $("#YardPlannerTextToEmail").val("");
    $("#YardPlannerTextMessage").text("");
    if (show) {
      var listData = {
        list: list,
        id: id,
      };
      var shareModalHtmlTemplate = Handlebars.compile(
        $("#YardPlannerShareListTemplate").html()
      );
      $("#modalShareListBg").hide().remove();
      ypUserLists.append(shareModalHtmlTemplate(listData));
      $("#modalShareListBg").addClass("is-showing");
    } else {
      $("#modalShareListBg").removeClass("is-showing");
    }
  };

  var shareListApi = function (listName, listId) {
    var errorDiv =
      $("#YardPlannerShareListError").length === 1
        ? $("#YardPlannerShareListError")
        : $("<div />", {
            id: "YardPlannerShareListError",
            class: "yard-planner-error",
          });
    var successDiv =
      $("#YardPlannerShareListSuccess").length === 1
        ? $("#YardPlannerShareListSuccess")
        : $("<div />", {
            id: "YardPlannerShareListSuccess",
            class: "yard-planner-success",
          });
    errorDiv.remove();
    successDiv.remove();
    var recipientEmail = $("#YardPlannerTextToEmail").val().trim();
    var recipientName = $("#YardPlannerTextToName").val().trim();
    var from = $("#YardPlannerTextFromName").val().trim();
    // var message = $("#YardPlannerTextMessage").text().trim();
    var valid = true;
    var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (recipientEmail == "" || !regex.test(recipientEmail)) {
      valid = false;
    }
    if (!valid || recipientEmail.length < 1) {
      errorDiv.html("Please enter a valid email address for recipient.");
      $("#YardPlannerShareModalActions").before(errorDiv);
      return false;
    }
    $.ajax({
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify({
        userId: ypUserId,
        toEmail: recipientEmail,
        recipientName: recipientName,
        senderName: from,
        wishlistName: listName,
      }),
      url:
        "https://ugz7uiahmb.execute-api.us-east-1.amazonaws.com/v1/wishlists/" +
        listId +
        "/sendEmailBB",
      success: function () {
        $("#modalShareList").removeClass("loading");
        window.dataLayer.push({
          event: "yardPlannerShareList",
          yardPlannerListName: listName,
          yardPlannerListId: listId,
          yardPlannerUserId: ypUserId,
        });
        $("#BtnShareListConfirm").addClass("visually-hidden");
        successDiv.html("<strong>'" + listName + "' has been shared!</strong>");
        $("#YardPlannerShareModalActions").before(successDiv);
        setTimeout(function () {
          showShareModal(false);
          $("#BtnShareListConfirm").removeClass("visually-hidden");
        }, 2500);
      },
      error: function (xhr, status, error) {
        $("#modalShareList").removeClass("loading");
        errorDiv.html(
          "Your list '" +
            listName +
            "' <em>could not</em> be shared! <p>" +
            error +
            "</p>"
        );
        $("#YardPlannerShareModalActions").before(errorDiv);
        console.error("xhr: ", xhr, "\nstatus: ", status, "\nerror: ", error);
      },
    });
  };

  var userLists = function (customerId) {
    ypUserId = customerId;
    ypSection = $("#YardPlannerSection-yard-planner-customer");
    $body = $("body");
    ypUserListsTemplate = Handlebars.compile(
      $("#YardPlannerUserListsTmpl").html()
    );

    ypUserLists = $("#YardPlannerUserLists");
    ypNameInput = $("#YardPlannerNewListName");
    ypButtonCreateList = $("#YardPlannerButtonCreateNewList");
    ypHiddenCustomer = $("#YardPlannerHiddenCustomer");

    ypButtonCreateList.on("click", function (e) {
      e.preventDefault();
      ypSection.addClass("loading");
      createList(createListUser);
    });
    getUserLists();
    ypUserLists.on(
      "click",
      ".faux-radio .faux-radio-list",
      handleVariantChange
    );
    ypUserLists.on("click", ".btn-yard-planner-add-to-cart", addItemToCart);
    ypUserLists.on(
      "click",
      ".yard-planner-list-header .yard-planner-header-name",
      toggleListsAccordion
    );
    ypUserLists.on("click", ".yard-planner-link-remove", function (e) {
      e.preventDefault();
      var $row = $(this).closest(".yard-planner-list-item");
      removeListItem($row);
    });
    ypUserLists.on("click", ".yard-planner-share-link", function (e) {
      e.preventDefault();
      var $header = $(this).closest(".yard-planner-list-header");
      var list = $header.find(".yard-planner-header-name span").text().trim();
      var id = $header.data("list");
      showShareModal(true, list, id);
    });
    ypUserLists.on("click", "#BtnShareListConfirm", function (e) {
      e.preventDefault();
      $("#modalShareList").addClass("loading");
      var listId = $(this).data("id");
      var listName = $(
        ".yard-planner-list-header.active .yard-planner-header-name span"
      )
        .text()
        .trim();
      shareListApi(listName, listId);
    });
    ypUserLists.on("click", "#BtnShareListDecline", function (e) {
      e.preventDefault();
      showShareModal(false);
    });
    ypUserLists.on("click", ".yard-planner-delete-list-link", function (e) {
      e.preventDefault();
      var listId = $(this).closest(".yard-planner-list-header").data("list");
      deleteUserList(listId);
    });
    ypUserLists.on("click", ".product-selector__adjust--plus", function (e) {
      e.preventDefault();
      var qtyBox = $(this).siblings(".product-selector__num");
      var val = parseInt(qtyBox.val().trim(), 10);
      qtyBox.val(val + 1);
    });
    ypUserLists.on("click", ".product-selector__adjust--minus", function (e) {
      e.preventDefault();
      var qtyBox = $(this).siblings(".product-selector__num");
      var val = parseInt(qtyBox.val().trim(), 10);
      if (val > 1) {
        qtyBox.val(val - 1);
      }
    });
    $("#YardPlannerCreateList").on("click", toggleCreateList);
  };

  module = {
    init: init,
    getLists: getLists,
    createList: createList,
    addToList: addToList,
    sharedList: sharedList,
    userLists: userLists,
  };

  return module;
})(yardPlanner || {}, jQuery);
